export class APIDomain {
  static origin(): string {
    return process.env.API_ORIGIN || 'http://localhost:3000';
  }

  static path(externalPath: string): string {
    return `${APIDomain.origin()}${externalPath}`;
  }
}
